import { FactoryTypes, FieldID } from "../../../models";

export const backupIphone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.makeSureConnectedToWifi,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.backupiCloudStep.text,
      image: FieldID.guideContainer.steps.backupiCloudStep.image,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.backupiCloudSelectionStep.text,
      image: FieldID.guideContainer.steps.backupiCloudSelectionStep.image,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.beginiCloudBackupStep.text,
      image: FieldID.guideContainer.steps.beginiCloudBackupStep.image,
    },
  },
  {
    type: FactoryTypes.EXPERT_HELP,
    fieldMapping: {
      buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
      title: FieldID.guideContainer.expertHelpContent.title,
      subtext: FieldID.guideContainer.expertHelpContent.subtext,
      secondaryButtonText:
        FieldID.guideContainer.expertHelpContent.secondaryButtonText,
      icon: FieldID.guideContainer.expertHelpContent.icon,
      supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
    },
  },
];
